import React, { FC } from 'react';
import { View, ViewStyle } from 'react-native';
import Svg, { Path, G } from 'react-native-svg';
import { useColors } from '../../hooks/useColors';
import { LOGO_RATIO } from '../../common/constants';

export interface LogoProps {
  height?: number;
  color: 'primary' | 'mono';
  containerStyle?: ViewStyle | ViewStyle[];
}

const Logo: FC<LogoProps> = ({ height, color, containerStyle }) => {
  const { colors } = useColors();
  const h = height || 18;
  const w = Math.ceil((height || 18) / LOGO_RATIO);

  return (
    <View testID="view-logo" style={containerStyle}>
      <Svg testID="svg-logo" width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <G
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity="0.2"
        >
          <G
            fillRule="nonzero"
            transform="translate(-557.000000, -1632.000000)"
            fill={color === 'mono' ? colors.text : colors.primary}
          >
            <G transform="translate(320.000000, 124.000000)">
              <G transform="translate(237.000000, 1492.000000)">
                <Path d="M58.2451404,16.3703704 C63.0803155,16.3703704 67,20.3168974 67,25.1851852 C67,30.053473 63.0803155,34 58.2451404,34 C53.4099653,34 49.4902808,30.053473 49.4902808,25.1851852 C49.4902808,20.3168974 53.4099653,16.3703704 58.2451404,16.3703704 Z M58.2451404,22.2711968 C56.6467353,22.2711968 55.3509719,23.5758338 55.3509719,25.1851852 C55.3509719,26.7945365 56.6467353,28.0991736 58.2451404,28.0991736 C59.8435455,28.0991736 61.1393089,26.7945365 61.1393089,25.1851852 C61.1393089,23.5758338 59.8435455,22.2711968 58.2451404,22.2711968 Z M43.7019438,16.3703704 L48.0431965,16.3703704 C48.442798,16.3703704 48.7667387,16.6965297 48.7667387,17.0988675 L48.7667387,33.2715029 C48.7667387,33.6738407 48.442798,34 48.0431965,34 L43.7019438,34 C43.3023424,34 42.9784017,33.6738407 42.9784017,33.2715029 L42.9784017,17.0988675 C42.9784017,16.6965297 43.3023424,16.3703704 43.7019438,16.3703704 Z M30.6781857,34 C30.2785843,34 29.9546436,33.6738407 29.9546436,33.2715029 L29.9546436,17.0988675 C29.9546436,16.6965297 30.2785843,16.3703704 30.6781857,16.3703704 L35.0194384,16.3703704 C35.4190399,16.3703704 35.7429806,16.6965297 35.7429806,17.0988675 L35.7429806,28.1720233 L41.5313175,28.1720233 C41.930919,28.1720233 42.2548596,28.4981826 42.2548596,28.9005204 L42.2548596,33.2715029 C42.2548596,33.6738407 41.930919,34 41.5313175,34 L30.6781857,34 Z M20.4762419,16.3703704 C25.311417,16.3703704 29.2311015,20.3168974 29.2311015,25.1851852 C29.2311015,30.053473 25.311417,34 20.4762419,34 C18.2222389,34 16.1671839,33.1423708 14.6154126,31.7335335 C13.0639813,33.1423442 11.0088973,34 8.75485961,34 C3.9196845,34 0,30.053473 0,25.1851852 C0,20.3168974 3.9196845,16.3703704 8.75485961,16.3703704 C11.0088973,16.3703704 13.0639813,17.2280261 14.6157606,18.6369024 C16.1671839,17.2279995 18.2222389,16.3703704 20.4762419,16.3703704 Z M20.4762419,22.2711968 C18.8778368,22.2711968 17.5820734,23.5758338 17.5820734,25.1851852 C17.5820734,26.7945365 18.8778368,28.0991736 20.4762419,28.0991736 C22.074647,28.0991736 23.3704104,26.7945365 23.3704104,25.1851852 C23.3704104,23.5758338 22.074647,22.2711968 20.4762419,22.2711968 Z M8.75485961,22.2711968 C7.1564545,22.2711968 5.86069114,23.5758338 5.86069114,25.1851852 C5.86069114,26.7945365 7.1564545,28.0991736 8.75485961,28.0991736 C10.3532647,28.0991736 11.6490281,26.7945365 11.6490281,25.1851852 C11.6490281,23.5758338 10.3532647,22.2711968 8.75485961,22.2711968 Z"></Path>
              </G>
            </G>
          </G>
        </G>
      </Svg>
    </View>
  );
};

export default Logo;
